export default "__VITE_ASSET__CpMHF$ho__"